/* unplugin-vue-components disabled */import script from "./Profile.vue?vue&type=script&setup=true&lang=js"
export * from "./Profile.vue?vue&type=script&setup=true&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=20e92e9a&lang=stylus"

const __exports__ = script;

export default __exports__